import { useControlStore, useModelStore } from '@editor/stores'

export interface LabelVisibilityFlags {
  showInnerWallLabels: boolean
  showOuterWallLabels: boolean
  showBeamLabels: boolean
  showVerticalSlabLabels: boolean
  showVerticalRoofSlabLabels: boolean
  showPurlinLabels: boolean
  showRipLabels: boolean
  showLintelLabels: boolean
  showColumnLabels: boolean
}

/**
 * Per-element-type floorplan label visibility, gated by the global "show
 * labels" toggle. Shared by `FloorplanModelLabels` (the batched render) and
 * `PlanLabelController` (which needs the same flags to build a selected
 * label's own descriptor).
 */
const useLabelVisibilityFlags = (): LabelVisibilityFlags => {
  const labelVisibilityModel = useModelStore(state => state.labelVisibilityModel)
  const showLabels = useControlStore(state => state.showLabels)

  return {
    showInnerWallLabels: showLabels && labelVisibilityModel.visibilityByType.inner_walls,
    showOuterWallLabels: showLabels && labelVisibilityModel.visibilityByType.outer_walls,
    showBeamLabels: showLabels && labelVisibilityModel.visibilityByType.beams,
    showVerticalSlabLabels: showLabels && labelVisibilityModel.visibilityByType.vertical_slabs,
    showVerticalRoofSlabLabels:
      showLabels && labelVisibilityModel.visibilityByType.vertical_roof_slabs,
    showPurlinLabels: showLabels && labelVisibilityModel.visibilityByType.purlins,
    showRipLabels: showLabels && labelVisibilityModel.visibilityByType.rips,
    showLintelLabels: showLabels && labelVisibilityModel.visibilityByType.lintels,
    showColumnLabels: showLabels && labelVisibilityModel.visibilityByType.columns,
  }
}

export default useLabelVisibilityFlags
